import classNames from "classnames";
import { type FC } from "react";
import { MediasLogo, type MediasVariant } from "~/features/navigation/components/TopBar/MediasLogo";
import { CompanyLogo } from "~/domains/company/components/CompanyLogo";
import { userIsPublic, userIsRegistered } from "~/domains/user/utils/roles";
import { styled } from "~/common/mui";

const HeaderBorder = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const CustomModalHeader: FC = () => {
  let userRole: MediasVariant;
  if (userIsPublic()) {
    userRole = "general";
  } else if (userIsRegistered()) {
    userRole = "plus";
  } else {
    userRole = "business";
  }

  return (
    <HeaderBorder className={classNames("container", "scha__logo-header")}>
      <MediasLogo variant={userRole} />
      <div className="scha__company-logo scha__header__logo">
        <CompanyLogo />
      </div>
    </HeaderBorder>
  );
};

export default CustomModalHeader;
